import { render, staticRenderFns } from "./siderList1.vue?vue&type=template&id=b35a8e9a&scoped=true&"
import script from "./siderList1.vue?vue&type=script&lang=js&"
export * from "./siderList1.vue?vue&type=script&lang=js&"
import style0 from "./siderList1.vue?vue&type=style&index=0&id=b35a8e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a8e9a",
  null
  
)

component.options.__file = "siderList1.vue"
export default component.exports